"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeTypeToInt = void 0;
const ferrum_plumbing_1 = require("ferrum-plumbing");
const stakeTypes = ['none', 'unser', 'timed', 'openEnded', 'publicSale'];
function stakeTypeToInt(t) {
    const rv = stakeTypes.indexOf(t);
    ferrum_plumbing_1.ValidationUtils.isTrue(rv >= 0, `Stake type ${t} not supported`);
    return rv;
}
exports.stakeTypeToInt = stakeTypeToInt;
//# sourceMappingURL=Types.js.map